$(function () {
    $(".icon-ancb-close").click(function() {
        $(".announcement").css('display', 'none');
    })
    
    $('.atc').click(function() {
      let productVariantID = this.dataset.vid;
      console.log(productVariantID)

      $(this).prop('disabled', true);

      let clickedBtn = $(this);
      
      let formData = {};
      formData.id = productVariantID;
      formData.quantity = 1;

      const xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function() {
          if (xhr.readyState == XMLHttpRequest.DONE) {
            clickedBtn.prop('disabled', false);
            jQuery('.js-drawer-open-right').click();
          }
      }
      xhr.open('POST', '/cart/add.js', true);
      xhr.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
      xhr.send(JSON.stringify(formData));
    })


    $('.burger').click(function() {
      let height =  $('.nav').offset().top - $(window).scrollTop() + 70;

      this.classList.toggle('active');

      let isAcive = $('.mobilemenu').hasClass("is-mobnav-acive");
      if (isAcive) {
        $('.mobilemenu').removeClass('is-mobnav-acive')
        $('._body').removeClass('body-fixed ');
      } else {
        $('.mobilemenu').addClass('is-mobnav-acive');
        $('.mobilemenu').css('top', height + 'px');
        $('.mobilemenu').css('height', `calc(100vh - ${height}px)`);
        $('._body').addClass('body-fixed');
      }
    })

})

$(document).ready(function() {
  $('#plus-btn').click(function() {
    $('.pdl').slideToggle("slow");
    $('.circle-plus').toggleClass('opened');
  });

  // $('.circle-plus').on('click', function(){
  //   $(this).toggleClass('opened');
  // })

  $('#marker-selector').change(function() {
    window.location = $(this).val();
  });

  $('#catagory-marker-selector').change(function() {
    window.location = $(this).val();
  });

});



$(document).ready(function(){
    $('.faq-info-wrapper').click(function(){
      $(this).children(".faq-expanded").toggleClass("active");
    //   $(this).children(".faq-expanded._01").slideToggle(1000);
  });
  });

  $(document).ready(function(){
    $('.faq-collapsed').click(function(){
        $(this).parents().children(".faq-expanded._01").slideToggle(500)
        $(this).children(".faq-icon-wrapper").children(".line-vertical-2").toggleClass("lineShow")
  });
  });

  $(document).ready(function(){
    $(".storyl-img").addClass("anim");
   });
   $(document).ready(function(){
    $(".marquee").addClass("mr-trans");
   });


  //  $(document).ready(function(){
  //   setInterval(function() {
  //     $(".mr-trans").css({"transform": "translateX(0)", "transition": "transform 15s linear"});
  //   }, 15000);
  //  });

  //  $(document).ready(function(){
  //   setInterval(function() {
  //     $(".mr-trans").css({"transform": "translateX(-98vw)", "transition": "transform 15s linear"});
  //   }, 26000);
  //  });


  $(function () { 
    let sectionId = $('#shopify-section-collection-filter');
    var distance; 


    if (sectionId && sectionId.offset()) {
      distance = $('#shopify-section-collection-filter').offset().top;
    }

    
    $(window).load(function() {
      if ($(window).scrollTop() >= distance - 100) {
        $('#shopify-section-collection-filter').addClass("fixed-on-head");

      } else {
          $('#shopify-section-collection-filter').removeClass("fixed-on-head");
      }
    })


    $(window).scroll(function () {

      if ($(window).scrollTop() >= distance - 100) {
          $('#shopify-section-collection-filter').addClass("fixed-on-head");
 
      } else {
          $('#shopify-section-collection-filter').removeClass("fixed-on-head");
      }
    });
  })
  

  $(document).ready(function(){ 
    $(".mn-toggle-btn").click(function() {
      
      let current = $('#' + this.id);
      

      let totalSubmenu = this.dataset.sub;
      let totalHeight = +totalSubmenu * 40;
      let idName = this.dataset.subclass;
      let isActive = $('#' + idName).hasClass('msubmenu-acitve');

      if (isActive) {
          current.removeClass('mn-toggle-active');
          $('#' + idName).removeClass('msubmenu-acitve');
          $('#' + idName).css('height', 0 + 'px');
          
      } else {
          current.addClass('mn-toggle-active');
          $('#' + idName).addClass('msubmenu-acitve');
          $('#' + idName).css('height', totalHeight + 'px');
      }

    })
})
$(document).ready(function() {
	$('.popup-with-form').click(function(e) {
      e.preventDefault();
      $('#search-form').show();
	});
  	$('.btn-close').click(function(e) {
      e.preventDefault();
      $('#search-form').hide();
	});
});

